import { DBCommercialProduct } from "@Commercial/Products/Data/DataSource/API/Entity/Product"

export const injectActive = (products: DBCommercialProduct[]) => {
    return products.map((product) => {
        return {
            ...product,
            active: true
        }
    })
}